import { BehaviorSubject, Observable, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';

import { GridApi } from 'ag-grid-community';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  gridApi = new BehaviorSubject<GridApi | null>(null); // Store Grid API globally
  isCollapsed = new BehaviorSubject(false)
  CurrentNavActiveItem = new BehaviorSubject([])
  extraNavActiveItem = new BehaviorSubject('')
  bankIdSelected = new BehaviorSubject(null)
  sidebarToggled: any;
  laptopView: any = window.innerWidth >= 992;

  constructor(public http: HttpClient) {
    const screenWidth = window.innerWidth;
    this.laptopView = screenWidth >= 992;

    // Set collapsed based on screen size
    this.isCollapsed.next(screenWidth < 992);

    // this.setResponsiveState();

    // window.addEventListener('resize', () => {
    //   this.setResponsiveState();
    // });
  }

   setResponsiveState() {
    const screenWidth = window.innerWidth;
    this.laptopView = screenWidth >= 992;
    this.isCollapsed.next(screenWidth < 992);
  }


  callPostAPI(path: any, payload: any) {
    return this.http.post<any>(environment.apiBaseUrl + path, payload);
  }

  callGetAPI(path: any) {
    return this.http.get<any>(environment.apiBaseUrl + path);
  }

  callV2GetAPI(path: any) {
    return this.http.get<any>(environment.apiBaseUrl2 + path);
  }

  callPutAPI(path: any, payload: any) {
    return this.http.put<any>(environment.apiBaseUrl + path, payload);
  }

  callPatchAPI(path: any, payload: any) {
    return this.http.patch<any>(environment.apiBaseUrl + path, payload);
  }

  callDeleteAPI(path: any) {
    return this.http.delete<any>(environment.apiBaseUrl + path);
  }

  getJSON(type: any): Observable<any> {
    if (type == 'language') {
      return this.http.get<any>('assets/json/language.json')
    }
    else if (type == 'id') {
      return this.http.get<any>('assets/json/id.json')
    }
    else if (type == 'currency') {
      return this.http.get<any>('assets/json/currency.json')
    }
    else {
      return this.http.get<any>('assets/json/country.json')
    }
  }

  getCountryList() {
    return this.http.get<any>(environment.apiBaseUrl + '/api/v1.1/get-country-currency-list');

  }


  // Method to trigger grid resize
  resizeGrid() {
    const api = this.gridApi.getValue();
    if (api) {
      setTimeout(() => {
        api.redrawRows()
        if(this.laptopView)
          {
            api.sizeColumnsToFit();
          }
      }, 500);
    }
  }
}
